import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { finishSocialPulseLogin } from "@/lib/socialpulseOidc";

export default function SocialPulseCallback() {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    finishSocialPulseLogin()
      .then((user) => {
        toast.success(`Welcome, ${user?.name || "cinephile"}!`);
        navigate("/", { replace: true });
      })
      .catch((e) => setError(e?.response?.data?.detail || e.message || "Login failed"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main data-testid="sso-callback-page" className="max-w-xl mx-auto px-6 py-28 text-center">
      {error ? (
        <>
          <p className="font-display text-2xl text-[#7d1a1a]">Sign-in didn't complete</p>
          <p data-testid="sso-error" className="text-sm text-[#6b5d51] mt-3">{error}</p>
          <button onClick={() => navigate("/")} className="mt-6 bg-[#1c1512] text-[#f6f1e7] px-6 py-2.5 font-medium hover:bg-[#7d1a1a] transition-colors">
            Back to MoviePulse
          </button>
        </>
      ) : (
        <>
          <Loader2 className="w-8 h-8 animate-spin text-[#7d1a1a] mx-auto" />
          <p className="font-display text-2xl text-[#6b5d51] mt-4">Signing you in with SocialPulse…</p>
        </>
      )}
    </main>
  );
}
